import { Result, Space, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PrimaryButton } from 'components';
import EnquirySubmittedIcon from 'assets/images/enquiry-submitted-icon.svg';

interface SurgeryEnquiryFinishResultProps {
  enquiryReference: string;
}

export const SurgeryEnquiryFinishResult = ({ enquiryReference }: SurgeryEnquiryFinishResultProps): JSX.Element => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Result
      icon={<img src={EnquirySubmittedIcon} />}
      title={t('enquiry.success.message')}
      subTitle={`${t('enquiry.success.reference', { referenceNumber: enquiryReference })}`}
      extra={
        <Space direction="vertical">
          <Typography.Text>{t('benefits.surgery.description')}</Typography.Text>
          <PrimaryButton onClick={() => navigate('/home')}>{t('common.error.returnHome')}</PrimaryButton>
        </Space>
      }
    />
  );
};
